<template lang="pug">
  div
    el-row.container(type="flex")
      el-col
        h2.titulo Arrecadação de terras
      el-col
        .button
          el-button(
          @click="criarCadastroColetivo",
          type="success",
          icon="el-icon-plus"
        )
            span.center Criar processo
    el-row
      el-col
        pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
        )
    el-card.card-container(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de cadastros",
        @click="getProcessosArrecadacao",
        :hasButton="true"
        content="Atualizar retificações"
      )
      table-generica(
        :colunas="colunas",
        :botoesAcao="botoesAcao",
        :sortChanged='sortChanged',
        :dados='processosArrecadacao'
        )
      app-paginacao(
        :total="totalCadastros"
        :pagina="pagina",
        @changePage="changePage"
      )
</template>

<script>
import { mapActions } from 'vuex'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import TableGenerica from '@/components/TableGenerica'
import Pesquisa from '@/components/Pesquisa'
import STATUS from '@/constants/statusProcessoArrecadacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
const { router } = require('@/utils/' + process.env.ESTADO + '/regrasArrecadacao').default

const filtro = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  withoutStatus: [
    STATUS.AGUARDANDO_VALIDACAO_CADASTRO,
    STATUS.AGUARDANDO_VALIDACAO_RETIFICACAO,
    STATUS.VALIDACAO_EM_ANDAMENTO,
    STATUS.AGUARDANDO_GERACAO_DOCUMENTOS
  ]
}

export default {
  data () {
    return {
      colunas: [
        {
          prop: 'numeroProcesso',
          label: 'Processo',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.gleba',
          label: 'Gleba',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'dataChegadaSetor',
          label: 'Data',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.municipios[0].nome',
          label: 'Município',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'statusName',
          label: 'Situação',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        }
      ],
      processosArrecadacao: [],
      totalCadastros: 0,
      filtro,
      CONFIGS,
      Utils
    }
  },

  components: {
    AppPaginacao,
    AppDividerRefreshButton,
    TableGenerica,
    Pesquisa
  },
  mixins: [AppNotificacao],

  computed: {
    pagina () {
      return filtro.pagina + 1
    }
  },
  methods: {
    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getProcessosArrecadacao()
    },
    criarCadastroColetivo () {
      this.$router.push({
        name: router.NEW_CADASTRO
      })
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.filtro.simplificado = true
      this.getProcessosArrecadacao()
    },

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.changePage(1)
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.getProcessosArrecadacao()
    },

    async retificarCadastro (processo) {
      if (processo.status === 'CADASTRO_EM_REVISAO') await this.tramitarRevisao(processo.id)
      this.$router.push({
        name: router.RETIFICAR,
        query: {
          idCadastroColetivo: processo.cadastroColetivo.id
        }
      })
    },

    botoesAcao (processo) {
      switch (processo.status) {
        case 'CADASTRO_EM_ANDAMENTO':
          return [
            {
              click: this.editarCadastroColetivo.bind(
                this,
                processo
              ),
              icon: 'edit',
              title: 'Continuar',
              active: true
            },
            {
              click: this.deletar.bind(this, processo),
              icon: 'delete',
              title: 'Deletar Processo',
              active: true
            }
          ]

        default:
          return [
            {
              click: this.retificarCadastro.bind(this, processo),
              icon: 'edit',
              title: 'Retificar',
              active: true
            }
          ]
      }
    },

    editarCadastroColetivo (processo) {
      this.$router.push({
        name: router.EDITAR,
        query: {
          idCadastroColetivo: processo.cadastroColetivo.id,
          isResumo: !!processo.isResumo
        }
      })
    },

    getProcessosArrecadacao () {
      this.findProcessosArrecadacao(this.filtro).then(response => {
        this.processosArrecadacao = response.processosArrecadacao
        this.totalCadastros = response.total
      })
    },

    async deletar (processo) {
      this.confirmBox(
        this.$messages.MSG_CONFIRMACAO,
        this.$messages.TITULO_WARNING,
        async () => {
          await this.deleteById(processo.id)
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.DELETE
          )
          this.getProcessosArrecadacao()
        },
        () => {},
        'Confimar',
        'Cancelar'
      )
    },

    ...mapActions({
      tramitarRevisao: 'processoArrecadacao/tramitarRevisao',
      findProcessosArrecadacao: 'processoArrecadacao/find',
      deleteById: 'processoArrecadacao/deleteById'
    })
  },

  async created () {
    this.getProcessosArrecadacao()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container {
  display: flex;
  width: 100%;
  min-height: 100%;
}
.card-container {
  border-radius: 12px;
}

.titulo {
  color: $--color-primary;
  margin-top: 3px;
}

.table {
  width: 100%;
}

.button {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/Home.vue